module.exports = __webpack_public_path__ + "static/media/Plymouth-Village-Third-Amendment-to-Master-Deed.04ff201f.pdf";